import React from 'react';
import aboutImage from './../assets/pexels/about-3.jpg'

const AboutMore = () => {
  return (
    <section className="py-10">      
      <div className="container mx-auto px-5 mt-6">
        <div className="grid md:grid-cols-2 gap-10 items-center">
        <div className="relative min-h-[500px]">
            <img
              className="absolute w-full h-full object-cover rounded-lg"
              src={aboutImage}
              alt="About Us"
            />
          </div>
          <div>   
            <h1 className="uppercase text-lg font-bold my-1">Technology and Innovation</h1>
            <p className="mb-4 text-justify">
            PocketLPO harnesses the power of advanced legal technologies, including AI-driven tools, to streamline processes and enhance
            service delivery. By integrating cutting-edge solutions, we provide faster turnaround times, improved accuracy, and cost savings for our clients.
            </p>
            <h1 className="uppercase text-lg font-bold my-1">Global Reach and Market Presence</h1>
            <p className="mb-4 text-justify">
            PocketLPO is proud to support clients across diverse industries and jurisdictions. Whether you are a startup, SME, or a large corporation,
             our services are designed to adapt to your unique legal requirements, offering global compliance and scalability
            </p>
            <h1 className="uppercase text-lg font-bold my-1">Vision and Impact</h1>
            <p className="mb-4 text-justify">
            At PocketLPO, we are actively reshaping the legal outsourcing industry through continuous innovation and a commitment to accessibility.
            By delivering high-quality legal support with unmatched efficiency and affordability, we have established ourselves as a leader in legal process outsourcing, setting new benchmarks for excellence in the field.
            </p>
            <h1 className="uppercase text-lg font-bold my-1">Our Commitment</h1>
            <p className="mb-4 text-justify">
            At PocketLPO, we prioritize transparency, efficiency, and excellence. Our services are designed to help businesses stay compliant, mitigate risks, and achieve growth without the complexity of traditional legal solutions.
            </p>

          </div>          
        </div>
      </div>
    </section>
  );
};

export default AboutMore;
